let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("i6hbj")).then(() => parcelRequire('55Msa'));